import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import TemplateCommon from '../../../../app/helpers/template-common';
import DataService from '../../services/data.service';
import DataServiceSecure from '../../services/data-secure.service';
import UtilsService from '../../../../services/utils.service';
import kpiAndTrendOptions from '../../dialogs/panel-options/kpi-n-trend-options/kpi-n-trend-options';
import kpiAndTrendService from '../panel/kpi-n-trend-panel.service';
import '../../../../app/bindings/ko-custombinding-highcharts';

const TREND_TYPE_DEFAULT_VALUE = 'simple';
const TREND_TYPE_STACKED_VALUE = 'stacked';
const TREND_TYPE_PERCENT_VALUE = 'percentStacked';

function TrendPanel(params) {
    var self = this;

    self.panelId = _.get(params, 'panelId');
    self.dateRangeModel = _.get(params, 'dateRange');

    self.panelOptionsUpdatedSignal = _.get(params, 'signals.panelOptionsUpdated');
    self.showLoadingIconSignal = _.get(params, 'signals.showLoadingIcon');
    self.titleChangedSignal = _.get(params, 'signals.titleChanged');
    if (!_.isNil(self.titleChangedSignal)) {
        self.titleChangedSignal.add(function(title) {
            var selectedOptions = ko.unwrap(self.selectedOptions);
            self.selectedOptions(_.assign(selectedOptions, { title: title }));
        });
    }

    self.showOptionsSignal = _.get(params, 'signals.showOptions');
    if (!_.isNil(self.showOptionsSignal)) {
        self.showOptionsSignal.add(self.onShowOptions.bind(self));
    }

    // //  FIXME: what's this signal for? - 'panel' complains when missing..    :O
    // self.resizeSignal = params.signals.resizeSignal;

    kpiAndTrendService.migrate(params);
    self.selectedOptions = ko.observable(params.options);

    self.chartConfiguration = getChartConfiguration(null);

    self.dataAndOptions = ko.observable({
        data: self.chartConfiguration,
        legendLength: 0,
        clickCallback: _.noop,
        selectedIndexes: []
    });

    self.subscriptions = {};
    self.subscriptions.dateRange = self.dateRangeModel.currentRangeUpdated.add(self.fetchDataset, self);

    self.dispatchShowLoadingIcon(true);
    self.fetchDataset();
}

TrendPanel.prototype = {
    dispatchShowLoadingIcon: function (show) {
        var self = this;
        UtilsService.dispatchSignal(self.showLoadingIconSignal, show);
    },

    dispose: function () {
        var self = this;
        _.forEach(self.subscriptions, function (subscription) {
            if (typeof subscription.dispose === 'function') {
                subscription.dispose();
            } else if (typeof subscription.detach === 'function') {
                subscription.detach();
            }
        });
    },

    fetchDataset: function () {
        var self = this;
        var selectedDateRange = ko.unwrap(self.dateRangeModel.getCurrentRange());
        var selectedOptions = ko.unwrap(self.selectedOptions);

        var params = {
            start: selectedDateRange.startDate,
            end: selectedDateRange.endDate,
            name: selectedOptions.metricId,
            resultType: selectedOptions.analysisId,
            query: kpiAndTrendService.getApiReadyQueryTagFilters(selectedOptions.filters),
            group_by: _.isArray(selectedOptions.groupBy) ? selectedOptions.groupBy.join(',') : selectedOptions.groupBy,
            aggregation: selectedOptions.aggregateFunction,
            flatten: false,
            limit: 50, // todo show when we exceed the limit
            include_group_nice_names: true,
        };

        DataService
            .fetchMetricsMetadata()
            .then(function (metadata) {

                var selectedCategoryMetadata = _.find(metadata, function (item) {
                    return item.id === selectedOptions.categoryId;
                });

                var selectedMetricMetadata = _.find(selectedCategoryMetadata.metrics, function (item) {
                    return item.id === selectedOptions.metricId || (item.oldId && item.oldId === selectedOptions.metricId) ;
                });

                var selectedGroupByMetadata = _.find(selectedCategoryMetadata.filterOptions, function (item) {
                    return item.id === params.group_by && !_.get(item, 'excludeGroupBy');
                });

                if (!selectedMetricMetadata) {
                    selectedCategoryMetadata = _.find(selectedCategoryMetadata.models, function (item) {
                        return item.id === selectedOptions.modelId;
                    });

                    selectedMetricMetadata = _.find(selectedCategoryMetadata.metrics, function (item) {
                        return item.id === selectedOptions.metricId || (item.oldId && item.oldId === selectedOptions.metricId);
                    });


                }

                DataServiceSecure
                    .fetchMetrics(params)
                    .then(function (data) {
                        var isPercentage = _.includes(selectedOptions.metricId, 'percent');
                        self.chartConfiguration = getChartConfiguration(_.get(selectedMetricMetadata,'name'), data, isPercentage, params.group_by,
                                                                        _.get(selectedGroupByMetadata,'colors'), selectedOptions.trendType);

                        self.dataAndOptions({
                            data: self.chartConfiguration,
                            legendLength: 0,
                            clickCallback: _.noop,
                            selectedIndexes: []
                        });

                        self.dispatchShowLoadingIcon(false);
                    });
            });
    },

    onOptionsChanged: function (updatedOptions) {
        var self = this;
        var title = updatedOptions.params.title;

        var updatedPanelOptions = _.assign({},
            updatedOptions.panel,
            {
                id: ko.unwrap(self.panelId),
                params: {
                    options: updatedOptions.params
                }
            }
        );

        // if (!_.isNil(self.subscriptions.optionsChanged)) {
        //     self.subscriptions.optionsChanged.dispose();
        // }

        var selectedOptions = ko.unwrap(self.selectedOptions);
        self.selectedOptions(
            _.assign(selectedOptions, updatedOptions.params)
        );

        // self.subscriptions.optionsChanged = self.selectedOptions.subscribe(self.onOptionsChanged, self);

        UtilsService.dispatchSignal(self.titleChangedSignal, title);
        UtilsService.dispatchSignal(self.panelOptionsUpdatedSignal, updatedPanelOptions);

        self.fetchDataset();
    },

    onShowOptions: function () {
        var self = this;
        DataService
            .fetchMetricsMetadata()
            .then(function (metadata) {
                kpiAndTrendOptions
                    .dialog({
                        metadata: metadata,
                        selections: _.cloneDeep(ko.unwrap(self.selectedOptions))
                    })
                    .then(function (selectedOptions) {
                        if (!_.isNil(selectedOptions)) {
                            self.onOptionsChanged(selectedOptions);
                        }
                    }, function(){})// no error handling needed on close);
            });
    }
};

function getChartConfiguration(metricDisplayName, data, isPercentage, isGroupBy, colors, trendType) {
    var configuration = getTrendBaseConfiguration();

    if (trendType && trendType !== TREND_TYPE_DEFAULT_VALUE) { // we ignore "simple" trend type because it requires no modifications to the chart config
      if (trendType === TREND_TYPE_STACKED_VALUE) {
        _.set(configuration, 'chart.type', 'area');
        _.set(configuration, 'plotOptions.area.stacking', 'normal');
        _.set(configuration, 'tooltip.footerFormat', '<br/>Total: <span class="highcharts-strong">{point.total}</span>');
      }
      if (trendType === TREND_TYPE_PERCENT_VALUE) {
        _.set(configuration, 'chart.type', 'area');
        _.set(configuration, 'plotOptions.area.stacking', 'percent');
        _.set(configuration, 'tooltip.pointFormat', '<span class="highcharts-color-{point.colorIndex}">●</span> {series.name}: <span class="highcharts-strong">{point.percentage:.1f}% ({point.y})</span><br/>');
      }
    }

    var series = [];
    moment.tz.setDefault(moment.tz.guess());
    if (!_.isEmpty(data) && !_.isEmpty(data.trend)) {
        if (!_.isEmpty(data) && !_.isEmpty(data.trend)) {
            if ( _.isArray(data.trend[0].group)) {
                _.forEach(data.trend, v => {
                    if (v && v.group) {
                        let nameRaw = _.map(v.group, g => g[1]).join(', ');
                        let name = _.map(v.group, g => g[3] ? g[3].replace(/{{time:(\d+)}}/, (match, p1) => moment.utc(Number(p1)).local().format('DD MMM YYYY - HH:mm:ss')) : g[1].replaceAll('_',' ')).join(', ');
                        if (!isGroupBy && name === '') {
                            name = metricDisplayName;
                        } else if (name === '') {
                            name = '(empty)';
                        } else if (isGroupBy && name.match(/^\*(, \*)*$/)) { // This regex matches one or more "*"s in the format "*, *, *" etc.
                            name = '(none)';
                        }

                        let seriesConfig = {
                            name: name,
                            data: v.data,
                        };
                        if (colors && _.get(colors, nameRaw)) {
                            seriesConfig.colorIndex = _.get(colors, nameRaw);
                        }
                        series.push(seriesConfig);
                    }
                });
            }
        }
    }

    series.sort((a, b) => {
      let alc = a.name.toLowerCase();
      let blc = b.name.toLowerCase();
      let an = +alc;
      let bn = +blc;
      // special cases to sort to the end of the series
      let exceptionMap = {
        '(empty)': true,
        '(none)': true,
        'unknown': true
      };

      // exceptions
      if (exceptionMap[alc] && !exceptionMap[blc]) {
        return 1;
      }
      if (!exceptionMap[alc] && exceptionMap[blc]) {
        return -1;
      }

      // numerical
      if (an === an && bn === bn) { // this checks if both strings are numbers, because NaN != NaN
        if (an < bn) {
          return -1;
        }
        if (an > bn) {
          return 1;
        }
        return 0;
      }

      // alphabetical
      if (alc < blc) {
        return -1;
      }
      if (alc > blc) {
        return 1;
      }
      return 0;
    });

    if (isPercentage) {
        _.forEach(series, function (s) {
            _.assign(s, {
                tooltip: {
                    valueDecimals: 2,
                    valueSuffix: '%',
                },
            });
        });

        _.assign(configuration.yAxis, {
            labels: {
                format: '{value:.2f} %',
            },
        });

    }

    _.set(configuration, 'series', series);

    return configuration;
}

function getTrendBaseConfiguration() {
    return _.assign({}, {
        title: false,
        chart: { styledMode: true, spacing: [10, 5, 0, 5], },
        time: { useUTC: false },
        tooltip: { shared: true },
        legend: { layout: 'horizontal', align: 'center', verticalAlign: 'bottom', borderWidth: 0, alignColumns: false },
        plotOptions: { series: { marker: { enabled: true, radius: 1 }, events: {}, label: { enabled: false, }, } },
        series: [ { data: [0], name: '' } ],
        xAxis: {
            type: 'datetime',
        },
        yAxis: {
            title: { text: null } ,
            min: 0,
            softMax: 1,
            minTickInterval: 1,
        },
        lang: {
            noData: "No Data To Display"
        },
        credits: { enabled: false }
    });
}

export default TrendPanel;
